import React, { useEffect, useState } from "react";
import { HtmlContentFrame } from "../../../components/HtmlContentFrame";
import { sourceImage } from "../../../utils/source-image";
import { getVestibularConfig } from "../../../services/vestibularesApi";
export default function VestibularesPage({ currentStudent }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let ativo = true;
    getVestibularConfig()
      .then((data) => {
        if (ativo) setConfig(data);
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });
    return () => {
      ativo = false;
    };
  }, []);
  const html = config?.html_url
    ? `<iframe src="${sourceImage(config.html_url)}" style="width:100%;min-height:70vh;border:none;" scrolling="yes"></iframe>`
    : "";
  return (
    <div className="ct">
      <h1 className="pt">
        <em>Vestibulares</em>
      </h1>

      {loading && (
        <div
          style={{
            color: "#64748B",
            fontSize: 13,
          }}
        >
          Carregando...
        </div>
      )}

      {!loading && !html && (
        <div
          style={{
            color: "#94A3B8",
            fontSize: 13,
          }}
        >
          Nenhum conteudo de vestibulares disponivel no momento.
        </div>
      )}

      {html && (
        <HtmlContentFrame
          html={html}
          title="Vestibulares"
          minHeight={600}
          instanceKey={`vestibulares:${currentStudent?.id ?? "anon"}`}
        />
      )}
    </div>
  );
}
export { VestibularesPage };
